/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { UploadResume } from 'src/pages/UploadResume/UploadResume';
import Login from 'src/pages/Login/Login';
import { useIsMobile } from 'src/hooks/use-mobile';
import logoImg from 'src/assets/images/logo.png';

export const AuthCard = ({
  onClose,
  onAuthSuccess,
  defaultTab = 'Sign in',
  activeTab: controlledActiveTab,
  onTabChange,
}) => {
  const [internalActiveTab, setInternalActiveTab] = useState(defaultTab);
  const isMobile = useIsMobile();

  // Sync internal state when defaultTab changes (uncontrolled mode)
  useEffect(() => {
    if (controlledActiveTab === undefined) {
      setInternalActiveTab(defaultTab);
    }
  }, [defaultTab, controlledActiveTab]);

  // Use controlled tab if provided, otherwise use internal state
  const activeTab =
    controlledActiveTab !== undefined ? controlledActiveTab : internalActiveTab;

  const setActiveTab = (tab) => {
    if (onTabChange) onTabChange(tab);
    else setInternalActiveTab(tab);
  };

  const isSignIn = activeTab === 'Sign in';

  return (
    <div className="tb-auth-card-wrap">
      {/* ── Card Header ── */}
      <div style={{ textAlign: 'center', marginBottom: 22 }}>
        <span className="flex items-center justify-center mb-2">
          <img src={logoImg} alt="Logo" className="w-12 h-10" />
        </span>
        
        <h2
          style={{
            fontFamily: "'Sora', sans-serif",
            fontSize: '1.125rem',
            fontWeight: 700,
            color: 'var(--ah-text-heading)',
            marginBottom: 4,
          }}
        >
          {isSignIn ? 'Welcome Back' : 'Join Us Today'}
        </h2>
        <p style={{ fontSize: '0.875rem', color: 'var(--ah-text-secondary)', margin: 0 }}>
          {isSignIn
            ? 'Sign in to your account'
            : 'Create your profile in under 2 minutes'}
        </p>

        {onClose && (
          <button
            type="button"
            onClick={onClose}
            style={{
              position: 'absolute',
              top: 16,
              right: 16,
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              color: 'var(--ah-text-secondary)',
              padding: 4,
              display: 'grid',
              placeItems: 'center',
            }}
            aria-label="Close"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        )}
      </div>

      {/* ── Tabs ── */}
      <div
        style={{
          display: 'flex',
          background: 'var(--ah-surface-input)',
          border: '1px solid var(--ah-border-progress)',
          borderRadius: 12,
          padding: 4,
          marginBottom: 8,
        }}
      >
        {['Create account', 'Sign in'].map((tab) => (
          <button
            key={tab}
            type="button"
            onClick={() => setActiveTab(tab)}
            style={{
              flex: 1,
              padding: '11px 16px',
              textAlign: 'center',
              fontSize: '0.875rem',
              fontWeight: 600,
              color: activeTab === tab ? '#fff' : 'var(--ah-text-secondary)',
              background: activeTab === tab ? 'var(--ah-brand-primary)' : 'none',
              border: 'none',
              cursor: 'pointer',
              borderRadius: 9,
              transition: 'all 0.3s ease',
              boxShadow:
                activeTab === tab
                  ? '0 2px 8px rgba(68, 114, 196, 0.2)'
                  : 'none',
              fontFamily: "'DM Sans', sans-serif",
            }}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* ── Content ── */}
      <div style={{ paddingTop: 22 }}>
        {activeTab === 'Create account' ? (
          <UploadResume onAuthSuccess={onAuthSuccess} />
        ) : (
          <Login
            setActiveTab={setActiveTab}
            isMobile={isMobile}
            onAuthSuccess={onAuthSuccess}
          />
        )}
      </div>
    </div>
  );
};
